import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { User, UserCreate, UserUpdate } from '@lockton-apps/shared/interfaces';
import { toFormData } from '@lockton-apps/shared/util/helpers';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  model = 'users';

  clientBrokersModel = 'users/brokers/client';

  constructor(
    @Inject('BASE_API_URL') private baseUrl: string,
    private http: HttpClient
  ) {}

  private _getUrlForId(id: string) {
    return `${this._getUrl()}/${id}`;
  }

  private _getUrl() {
    return `${this.baseUrl}/${this.model}`;
  }

  private _getUrlForClientBrokers(clientId: number) {
    return `${this.baseUrl}/${this.clientBrokersModel}/${clientId}`;
  }

  all() {
    return this.http.get<User[]>(this._getUrl());
  }

  allForClientId(clientId: number) {
    return this.http.get<User[]>(this._getUrlForClientBrokers(clientId));
  }

  load(id: string) {
    return this.http.get<User>(this._getUrlForId(id));
  }

  create(user: UserCreate) {
    const formData = toFormData(user);
    return this.http.post<User>(this._getUrl(), formData);
  }

  loadByBrokerT2Code(): Observable<User[]> {
    return this.http.get<User[]>(`${this._getUrl()}/brokers/t2code`);
  }

  update(user: UserUpdate) {
    const formData = toFormData(user);

    return this.http.patch<User>(this._getUrlForId(user.userId), formData);
  }

  enable(userId: string): Observable<void> {
    return this.http.put<void>(this._getUrl() + `/enable/${userId}`, null);
  }

  delete(user: User): Observable<void> {
    return this.http.put<void>(
      this._getUrl() + `/disable/${user.userId}`,
      null
    );
  }
}
